// Make the chatbot a private route
import { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from '../hooks/useAuth.js'

const PrivateRoute = ({ children }) => {

    
    const [isVerified, setIsVerified] = useState(null); // null to indicate loading
    const { verify } = useAuth()
    useEffect(() => {
        /*
        const verify = async () => {
            try {
                const response = await fetch('https://entssc.cas.mcmaster.ca/api/auth/verify', {
                    method: 'GET',
                    credentials: 'include' // Required to send cookies
                });

                setIsVerified(response.ok); // Set authentication status
            } catch (error) {
                console.error("Verification error:", error);
                setIsVerified(false);
            }
        };
        */
        const checkAuth = async () => {
            const verified = await verify();
            setIsVerified(verified);
        };

        checkAuth();
    }, []);

    if (isVerified === null) {
        return <p>Loading...</p>; // Show loading until verification is done
    }

    return isVerified ? children : <Navigate to="/login" />;
}

export default PrivateRoute